import { socials, profile } from "../data/content";

function SocialIcon({ type }) {
  const common = {
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
  };

  switch (type) {
    case "mail":
      return (
        <svg {...common}>
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <path d="m3 7 9 7 9-7" />
        </svg>
      );
    case "github":
      return (
        <svg {...common}>
          <path d="M9 19c-4 1.5-4-2-6-2m12 4v-3.5c0-1 .3-1.8 1-2.5 3.2-.4 4-1.8 4-4.2a3.5 3.5 0 0 0-1-2.5c.1-.4.4-1.8-.2-2.8s-1.8.4-3 .9a7 7 0 0 0-5.2 0c-1.2-.5-2.4-1.1-3-.9s-.3 2.4-.2 2.8a3.5 3.5 0 0 0-1 2.5c0 2.4.8 3.8 4 4.2.7.7 1 1.5 1 2.5V21" />
        </svg>
      );
    case "linkedin":
      return (
        <svg {...common}>
          <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z" />
          <rect x="2" y="9" width="4" height="12" />
          <circle cx="4" cy="4" r="2" />
        </svg>
      );
    case "x":
      return (
        <svg {...common}>
          <path d="M4 4l16 16M20 4 4 20" />
        </svg>
      );
    case "orcid":
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M8 8v8M8 12h4a3 3 0 0 0 0-6H8" />
        </svg>
      );
    case "scholar":
      return (
        <svg {...common}>
          <path d="M12 3 3 9l9 5 9-5-9-6z" />
          <path d="M5 11.5V17c0 1 3 3 7 3s7-2 7-3v-5.5" />
        </svg>
      );
    default:
      return null;
  }
}

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <p className="footer-name">{profile.name}</p>
        <div className="socials">
          {socials.map((s) => (
            <a
              key={s.label}
              href={s.href}
              className="social-link"
              target={s.href.startsWith("mailto:") ? undefined : "_blank"}
              rel={
                s.href.startsWith("mailto:")
                  ? undefined
                  : "noopener noreferrer"
              }
              aria-label={s.label}
              title={s.label}
            >
              <SocialIcon type={s.icon} />
              <span>{s.label}</span>
            </a>
          ))}
        </div>
        <p className="footer-note">© {new Date().getFullYear()} {profile.name}</p>
      </div>
    </footer>
  );
}
